import React from 'react'

const LeftArrow = () => {
  return (
    <svg
      width="8"
      height="12"
      viewBox="0 0 8 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.5 6L0.792893 5.29289L0.0857865 6L0.792893 6.70711L1.5 6ZM5.79289 0.292893L0.792893 5.29289L2.20711 6.70711L7.20711 1.70711L5.79289 0.292893ZM0.792893 6.70711L5.79289 11.7071L7.20711 10.2929L2.20711 5.29289L0.792893 6.70711Z"
        fill="white"
        fillOpacity="0.65"
      />
    </svg>
  )
}

export default LeftArrow
